<template>
    <div >
        <div class="nrk company">
            <p class="litext">Jilin Medical Design Institute Co., Ltd. (hereinafter referred to as Jilin Medical Design Institute) was founded in 1986 as a private enterprise, vice president unit of China Medical Engineering Design Association, and AAA credit enterprise in the survey and design industry of Jilin Province. We have a group of experienced and outstanding engineering designers, including design masters and government subsidized experts, registered practitioners, and personnel with senior and deputy professional titles. Various types of engineering and technical personnel account for over 90% of the total number of employees.</p>
            <img src="img/xt-1.jpg" class="litext-text">
            <!--公司简介-->
        </div>
        <div class="course nrks">
            <div class="course-nr nrk">
                <ul class="course-text">
                    <li>
                        <div><i>{{figure1}}</i><p>+</p></div>
                        <span class="wow animate__animated animate__bounce">25 years of development history</span>
                    </li>
                    <li>
                        <div><i>{{figure2}}</i><p>+</p></div>
                        <span class="wow animate__animated animate__bounce" data-wow-delay="0.3s">More than 40 awards</span>
                    </li>
                    <li>
                        <div><i>{{figure3}}</i><p>+</p></div>
                        <span class="wow animate__animated animate__bounce" data-wow-delay="0.6s">More than 1000 high-quality customers</span>
                    </li>
                    <li>
                        <div><p>+</p><i>{{figure4}}</i></div>
                        <span class="wow animate__animated animate__bounce" data-wow-delay="0.9s">Over 4700 projects</span>
                    </li>   
                </ul>
            </div>
        </div>
        <div class="nrk liesc">
            <div v-for="(item,index) in studyEnglish" :key="index">
                <div class="letr">
                    <img :src="n+(index+1)+'.jpg'">
                    <p>{{item.name}}</p>
                </div>
                <div class="rlis"><span>{{item.text}}</span></div>
            </div>
        </div>
    </div>
    
</template>

<script>
import {mapState} from "vuex"
export default {
    data() {
        return {
            figure1: 37,
            figure2: 40,
            figure3: 1000,
            figure4: 4700,
            faiked: false,
            liedn: 0,
            linq: 0,
            data:{
                type:2
            },
            n:'img/n-'
        }
        
    },
    mounted() {
    },
    computed:{
		...mapState({
			studyEnglish:state=>state.share.studyEnglish,
            About:state=>state.share.About
		})
        
	},
}
</script>

<style scoped>
    .company{
        margin: 2% auto;
        overflow: hidden;
    }
    .litext{
        width: 60%;
        float: left;
        padding-top: 1%;
        font-size: 18px;
        line-height: 40px;
        text-align: justify;
        text-indent: 2em;
    }
    .litext-text{
        width: 36%;
        float: right;
    }
    .course {
        width: 100%;
        background: url(@/assets/beij_2.jpg) no-repeat center center;
        overflow: hidden;
        margin-top: 90px;
    }

    .course-nr {
        margin: 0 auto;
        margin-top: 60px;
        margin-bottom: 60px;
    }

    .course-text {
        width: 100%;
        overflow: hidden;
    }

    .course-text li {
        float: left;
        width: 25%;
        height: 110px;
    }
    .course-text li:nth-child(2){
        text-align: center;
    }
    .course-text li:nth-child(2) i{
        margin-left:120px;
    }
    .course-text li:nth-child(3){
        text-align: center;
    }
    .course-text li:nth-child(3) i{
        margin-left:60px;
    }
    .course-text li:last-child{
        text-align: right;
    }
    .course-text li:last-child span{
        text-align: right;
        margin-right: 37px;
    }
    .course-text li:last-child i{
        float: right;
    }
    .course-text li:last-child p{
        float: right;
    }
    .course-text li>div{
        font-size: 76px;
        color: #fff;
        font-weight: bold;
        overflow: hidden;
    }

    .course-text li p {
        font-size: 50px;
        float: left;
    }

    .course-text span {
        font-size: 28px;
        margin-top: 30px;
        color: #fff;
        display: block;
    }

    .course-text li>div i {
        float: left;
    }
    .course-bottom-text {
        font-size: 26px;
        margin-top: 70px;
        color: #fff;
        text-align: justify;
        line-height: 50px;
        margin-bottom: 200px;
    }
    .liesc{
        margin-top: 40px;
        overflow: hidden;
    }
    .liesc>div{
        width: 43%;
        float: left;
        margin-right: 4%;
        border: 1px #eee solid;
        border-radius: 15px;
        padding: 1% 2%;
        margin-bottom: 24px;
    }
    .liesc>div:nth-child(2n){
        margin-right: 0%;
    }
    .letr{
        width: 26%;
        border-right: 1px #eee solid;
        float: left;
        margin-top: 10px;
    }
    .letr img{
        width: 60%;
        margin: 0 auto;
        display: block;
    }
    .letr p{
        text-align:center;
        font-size: 16px;
        font-weight: bold;
        margin-top: 6px;
    }
    .liesc .rlis{
        width: 63%;
        float: right;
        font-size: 14px;
        text-align: justify;

        height: 160px;
        overflow: auto;
        text-indent: 2em;
        padding: 24px 2%;
    }
    .rlis::-webkit-scrollbar { width: 10px;}
    .rlis::-webkit-scrollbar-track { background-color: #e9e9f4;  border-radius: 100px;}
    .rlis::-webkit-scrollbar-thumb { box-shadow: inset 0 0 6px #002cd0;  border-radius: 100px;}
    .rlis::-webkit-scrollbar {width: 10px;} 
    .liesc .rlis span{
        display: block;
        margin-top: 20px;
    }

    @media (max-width: 768px){
        .litext{
            width: 100%;
            font-size: 16px;
            line-height: 30px;
        }
        .litext-text{
            width: 100%;    
        }
        .liesc>div{
            width: 100%;
        }
        .liesc .rlis span{
            margin-top: 0;
        }
        .liesc .rlis{
            margin-right: 5%;
            width: 60%;
        }
        .letr{
            margin-top: 60px;
        }
        .rlis::-webkit-scrollbar { width: 10px;}
        .course{
            margin-top: 40px;
        }
        .course-text span{
            font-size: 14px;
            text-align: center;
            margin-top: 12px;
        }
        .course-text li{
            width: 50%;
            margin-bottom: 20px;
        }
        .course-text li>div{
            font-size: 40px;
            display: flex;
            justify-content: center;
        }
        .course-text li:nth-child(2) i{
            margin-left: 16px;
        }
        .course-text li p{
            font-size: 24px;
        }
        .course-text li:nth-child(3) i{
            margin-left: 12px;
        }
        .course-nr{
            margin-top: 40px;
            width: auto;
            margin-bottom: 20px;
        }
    }
</style>